'use client'
import styles from './Assessment.module.scss'
import Link from 'next/link'
import { MouseEventHandler, MouseEvent } from 'react'
import { AssessmentData } from '@crystal-eyes/lib/assessments'

const PREVIOUS_TEXT = 'Previous'
const NEXT_TEXT = 'Next'
const SUBMIT_TEXT = 'Submit'

export default function Assessment({
  onFinish,
  data,
  customStyleOption,
  customStyleContainer,
  line,
  assessmentContext,
}: {
  onFinish?: () => void
  data: AssessmentData
  customStyleOption?: string
  customStyleContainer?: string
  line?: boolean
  assessmentContext: any
}) {
  const {
    currentQuestion,
    currentAnswer,
    currentQuestionIndex,
    more,
    answerQuestion,
    goToQuestion,
    progress,
    submit,
    submitting,
  } = data

  const { title, instructions, leftText, rightText } = assessmentContext

  const ratingOnclick =
    (rating: number): MouseEventHandler<HTMLAnchorElement> =>
    (evt: MouseEvent) => {
      evt.preventDefault()
      answerQuestion(currentQuestion, rating)
    }

  return (
    <div className={styles.mbti}>
      <div className="heading">
        <h2>{title}</h2>
      </div>

      <div className="progress-bar">
        <div className="bar" style={{ width: `${progress}%` }} />
      </div>

      <div className="question-nav">
        <Link
          href="#"
          onClick={evt => {
            evt.preventDefault()
            goToQuestion(currentQuestionIndex - 1)
          }}
          className={`previous ${
            currentQuestionIndex > 0 ? 'activated' : 'deactivated'
          }`}
        >
          {`<`} <span>{PREVIOUS_TEXT}</span>
        </Link>

        <p>{instructions}</p>

        <Link
          href="#"
          onClick={evt => {
            evt.preventDefault()
            goToQuestion(currentQuestionIndex + 1)
          }}
          className={`next ${
            currentAnswer && more ? 'activated' : 'deactivated'
          }`}
        >
          <span>{NEXT_TEXT}</span> {`>`}
        </Link>
      </div>
      {'question' in currentQuestion && (
        <div className="centerQuestion">{currentQuestion.question}</div>
      )}

      <div className="response-area">
        <div className="question">
          {('left' in currentQuestion && currentQuestion.left) || leftText}
        </div>
        <div className={'rating' + ` ${customStyleContainer}`}>
          {line && <div className="line" />}

          <Link
            href="#"
            onClick={ratingOnclick(1)}
            className={
              'assessmentOption ' +
              `${customStyleOption ? 'removeScale' : null} ` +
              (currentAnswer === 1 ? 'selected' : 'unselected')
            }
          >
            <div className={'rating-number' + ` ${customStyleOption}`}>1</div>
          </Link>

          <Link
            href="#"
            onClick={ratingOnclick(2)}
            className={
              'assessmentOption ' +
              `${customStyleOption ? 'removeScale' : null} ` +
              (currentAnswer === 2 ? 'selected' : 'unselected')
            }
          >
            <div className={'rating-number' + ` ${customStyleOption}`}>2</div>
          </Link>

          <Link
            href="#"
            onClick={ratingOnclick(3)}
            className={
              'assessmentOption ' +
              `${customStyleOption ? 'removeScale' : null} ` +
              (currentAnswer === 3 ? 'selected' : 'unselected')
            }
          >
            <div className={'rating-number' + ` ${customStyleOption}`}>3</div>
          </Link>

          <Link
            href="#"
            onClick={ratingOnclick(4)}
            className={
              'assessmentOption ' +
              `${customStyleOption ? 'removeScale' : null} ` +
              (currentAnswer === 4 ? 'selected' : 'unselected')
            }
          >
            <div className={'rating-number' + ` ${customStyleOption}`}>4</div>
          </Link>

          <Link
            href="#"
            onClick={ratingOnclick(5)}
            className={
              'assessmentOption ' +
              `${customStyleOption ? 'removeScale' : null} ` +
              (currentAnswer === 5 ? 'selected' : 'unselected')
            }
          >
            <div className={'rating-number' + ` ${customStyleOption}`}>5</div>
          </Link>
        </div>

        <div className="question">
          {('right' in currentQuestion && currentQuestion.right) || rightText}
        </div>
      </div>

      {progress === 100 && (
        <div className="submit-button">
          <button
            className="CE action-button"
            disabled={submitting}
            onClick={evt => {
              evt.preventDefault()
              submit().then(() => {
                if (onFinish) onFinish()
                window.location.reload()
              })
            }}
          >
            {SUBMIT_TEXT}
          </button>
        </div>
      )}
    </div>
  )
}
